function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#5768a8;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Icon-settings");

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  id: "spacer",
  className: "cls-1",
  width: 32,
  height: 32
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "settingsOutline",
  className: "cls-2 fill",
  d: "M27,16.76V15.23l1.92-1.68A2,2,0,0,0,29.29,11L26.93,7A2,2,0,0,0,25.2,6a2,2,0,0,0-.64.1l-2.43.82a9.89,9.89,0,0,0-1.31-.75l-.51-2.52a2,2,0,0,0-2-1.61H13.63a2,2,0,0,0-2,1.61l-.51,2.52a12.39,12.39,0,0,0-1.32.75L7.42,6.06A2.25,2.25,0,0,0,6.78,6,2,2,0,0,0,5.05,7L2.69,11a2,2,0,0,0,.41,2.51L5,15.24v1.53L3.1,18.45A2,2,0,0,0,2.69,21l2.36,4a2,2,0,0,0,1.73,1,2,2,0,0,0,.64-.1l2.43-.82a11.35,11.35,0,0,0,1.31.75l.51,2.52a2,2,0,0,0,2,1.61h4.72a2,2,0,0,0,2-1.61l.51-2.52a10.69,10.69,0,0,0,1.32-.75l2.42.82a2,2,0,0,0,.64.1A2,2,0,0,0,27,25l2.28-4a2,2,0,0,0-.41-2.51ZM25.2,24l-3.43-1.16a8.86,8.86,0,0,1-2.71,1.57L18.35,28H13.63l-.71-3.55a9.5,9.5,0,0,1-2.7-1.57L6.78,24,4.42,20l2.72-2.4a9.14,9.14,0,0,1,0-3.13L4.42,12,6.78,8l3.43,1.16a9.1,9.1,0,0,1,2.71-1.57L13.63,4h4.72l.71,3.55a9.23,9.23,0,0,1,2.7,1.57L25.2,8l2.36,4-2.72,2.4a8.67,8.67,0,0,1,0,3.13L27.56,20ZM16,22a6,6,0,1,1,6-6,5.93,5.93,0,0,1-5.87,6Zm0-10a3.92,3.92,0,0,0-4,3.82V16a3.91,3.91,0,0,0,3.82,4H16a3.91,3.91,0,0,0,4-3.82A.54.54,0,0,0,20,16a3.9,3.9,0,0,0-3.81-4Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "settingsFill",
  className: "cls-1",
  d: "M27,16.76V15.23l1.92-1.68A2,2,0,0,0,29.29,11L26.93,7A2,2,0,0,0,25.2,6a2,2,0,0,0-.64.1l-2.43.82a9.89,9.89,0,0,0-1.31-.75l-.51-2.52a2,2,0,0,0-2-1.61H13.63a2,2,0,0,0-2,1.61l-.51,2.52a12.39,12.39,0,0,0-1.32.75L7.42,6.06A2.25,2.25,0,0,0,6.78,6,2,2,0,0,0,5.05,7L2.69,11a2,2,0,0,0,.41,2.51L5,15.24v1.53L3.1,18.45A2,2,0,0,0,2.69,21l2.36,4a2,2,0,0,0,1.73,1,2,2,0,0,0,.64-.1l2.43-.82a11.35,11.35,0,0,0,1.31.75l.51,2.52a2,2,0,0,0,2,1.61h4.72a2,2,0,0,0,2-1.61l.51-2.52a10.69,10.69,0,0,0,1.32-.75l2.42.82a2,2,0,0,0,.64.1A2,2,0,0,0,27,25l2.28-4a2,2,0,0,0-.41-2.51Zm-7-.58A3.91,3.91,0,0,1,16,20h-.18A3.91,3.91,0,0,1,12,16v-.18A3.92,3.92,0,0,1,16,12h.19A3.9,3.9,0,0,1,20,16,.54.54,0,0,1,20,16.18Z"
});

var SvgSettings = function SvgSettings(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings.849fae20.svg";
export { ForwardRef as ReactComponent };